export const LOCAL_LINE_TYPE = 'LINE_LOCAL';
export const TOLL_FREE_LINE_TYPE = 'LINE_FREE';
export const BUSINESS_ACCOUNT_TYPE = 'BUSINESS';
export const PERSONAL_ACCOUNT_TYPE = 'PERSONAL';
export const AUTOMATIC_SWAP_MODE = 'automatic';
export const MANUAL_SWAP_MODE = 'manual';
export const GOOGLE_ADS = 'google-ads';
export const ZAPIER = 'zapier';
export const HUBSPOT = 'hubspot';
export const REGULAR_CAMPAIGN_TYPE = 'REGULAR_CAMPAIGN';
export const DNI_CAMPAIGN_TYPE = 'DYNAMIC_CAMPAIGN';
export const MINIMUM_POOL_SIZE = 4;
export const MAXIMUM_POOL_SIZE = 50;
